{
	"addMenu": "Ajouter un nouveau menu",
	"create": "Créer un menu",
	"day": "Jour",
	"editMenu": "Modifier le menu",
	"end": "Fin",
	"endTime": "Heure de fin",
	"menuForm": {
		"delivery": "Livraison",
		"table": "Commande à table"
	},
	"menuInformation": "Informations sur le menu",
	"name": "Nom du menu",
	"save": "Sauvegarder les modifications",
	"start": "Début",
	"startTime": "Heure de début",
	"type": "Type de menu",
	"validateField": "Champ obligatoire",
	"workingPeriods": "Horaires d'ouverture du menu"
}
